import React from 'react'
import { Card } from 'components/ui'

const AspectRatioCard = ({ sizeOption, isSelected, onSelect }) => {
    // Generate dynamic icon based on aspect ratio
    const generateIcon = (aspectRatio) => {
        const [width, height] = aspectRatio.split(':').map(Number);
        const ratio = width / height;

        // Define icon styles based on aspect ratio
        if (ratio === 1) {
            // Square (1:1)
            return (
                <div className="w-10 h-10 border-2 border-gray-400 dark:border-gray-500 rounded flex items-center justify-center">
                    <div className="w-6 h-6 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                </div>
            );
        } else if (ratio > 1.5) {
            // Wide landscape (16:9, 4:3, etc.)
            return (
                <div className="w-12 h-8 border-2 border-gray-400 dark:border-gray-500 rounded flex items-center justify-center">
                    <div className="w-8 h-4 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                </div>
            );
        } else if (ratio > 1) {
            // Moderate landscape (3:2, etc.)
            return (
                <div className="w-11 h-8 border-2 border-gray-400 dark:border-gray-500 rounded flex items-center justify-center">
                    <div className="w-7 h-4 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                </div>
            );
        } else if (ratio < 0.7) {
            // Tall portrait (9:16, etc.)
            return (
                <div className="w-8 h-12 border-2 border-gray-400 dark:border-gray-500 rounded flex items-center justify-center">
                    <div className="w-4 h-8 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                </div>
            );
        } else {
            // Moderate portrait (2:3, 3:4, etc.)
            return (
                <div className="w-8 h-11 border-2 border-gray-400 dark:border-gray-500 rounded flex items-center justify-center">
                    <div className="w-4 h-7 bg-gray-300 dark:bg-gray-600 rounded-sm"></div>
                </div>
            );
        }
    };

    return (
        <Card 
            className={`relative cursor-pointer transition-all duration-200 hover:shadow-md border-2 ${
                isSelected 
                    ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20' 
                    : 'border-gray-200 dark:border-gray-700 hover:border-purple-300'
            }`}
            onClick={() => onSelect(sizeOption.id)}
            bodyClass="!px-0"
        >
            <div className="p-0 text-center flex items-center justify-center flex-col h-full">
                <div className="mb-2 flex justify-center">
                    {generateIcon(sizeOption.aspect_ratio)}
                </div>
                <div className="font-semibold text-gray-900 dark:text-white">
                    {sizeOption.aspect_ratio}
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1 capitalize">
                    {sizeOption.category}
                </div>
            </div>

            {/* Selection indicator */}
            {isSelected && (
                <div className="absolute top-2 right-2">
                    <div className="w-4 h-4 bg-purple-500 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                    </div>
                </div>
            )}
        </Card>
    );
}

export default AspectRatioCard
